import React from 'react';
import { Outlet } from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute';
import { AdminRealtimeDataProvider } from '../context/AdminRealtimeDataContext';

export default function ProtectedLayout() {
  return (
    <ProtectedRoute>
      <AdminRealtimeDataProvider>
        <Outlet />
      </AdminRealtimeDataProvider>
    </ProtectedRoute>
  );
}
